import { useMemo } from 'react';
import { useAsyncFn } from 'react-use';
import { useSetSession } from '../../../context/Session';
import { validateEmail } from '../../utils/inputValidation';
import { initiatePasswordReset } from '../api';

export const usePasswordReset = (email: string) => {
  const setSession = useSetSession();
  const invalidEmail = useMemo(() => !validateEmail(email), [email]);
  const [{ loading, error }, passwordReset] = useAsyncFn(initiatePasswordReset);

  const handlePasswordReset = async () => {
    // Clear user session authentication
    // even if the reset email input is not correct.
    setSession({ authenticated: false });

    return await passwordReset(email);
  };

  return {
    loading,
    error,
    invalidEmail,
    passwordReset: handlePasswordReset,
  };
};
